(function (ws) {
    'use strict';
    ws.views.accountPreferences = ws.views.googleAnalytics.extend({

        /**
         * event handlers
         */
        events: {
            'change .usi-content #country': 'updateResellersList',
            'change .usi-content #reseller': 'updateCurrency',
            'click .select-all': 'selectAll',
            'click .mainGroupSelection': 'selectRelatedCheckbox',
            'click [name="preferences"]': 'selectCheckBox',
            'click #submit': 'handleSubmitAccountsForm'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$countryDropdown = this.$('#country');
            this.$resellersList = this.$('.resellersList');
            this.consolidatedAccountsTemplate = _.template($('#consolidatedAccounts').html());
            this.currencyTemplate = _.template($('#currencyDropdownOptions').html());
            this.$currencyDropdown = this.$('#currency');
            this.accountTemplate = _.template($('#accountDropdownOptions').html());
            this.$resellerDropdown = this.$('#reseller');
            this.languageTemplate = _.template($('#languageDropdownOptions').html());
            this.$languageDropdown = this.$('#language');
            this.$submitButton = this.$('#submit');
            this.$selectedCheckboxes = $('[name="preferences"]:checked').not(':disabled').length;

            // Initialize Drop Down Model
            this.model = new ws.models.userSelectDropdownModel();
            this.currencyModel = new ws.models.userSelectDropdownModel({
                url: globals.path.api.westcon.populateCurrency
            });

            this.selectCheckBox();
        },

        /**
         * Handle submit accounts form
         */
        handleSubmitAccountsForm (e) {
            if ($('a#submit').is('[disabled=disabled]') == false) {
                e.stopPropagation();
                const form = this.$('#vendorListForm');
                const preferencesData = [];
                const preferencesAccountId = [];
                const preferencesAccountName = [];

                this.$('[name="preferences"]:checked').each((key, element) => {
                    preferencesData.push(element.value);
                    preferencesAccountId.push(element.value.slice(element.value.indexOf(':') + 1));
                });

                this.$('[name="preferences"]:checked + label').each(function(key, element) {
                    let text = $(element).text();
                    preferencesAccountName.push(text.slice(text.indexOf('-') + 2, text.lastIndexOf('-') - 2));
                });

                const submitForm = $.ajax({
                    type: 'POST',
                    url: form.attr('action'),
                    data: form.serialize()
                });

                submitForm.done(function (data) {
                    if (data === true) {
                        form.attr('action', globals.path.api.westcon.switchStoreReseller);
                        form.submit();
                    } else if (data === false) {
                        this.$('[name="code"]').attr('disabled', true);
                        this.$('[name="userGroupId"]').attr('disabled', true);
                        form.attr('action', globals.path.api.westcon.switchStoreReseller);
                        form.submit();
                    }
                }.bind(this)).fail(function () {
                    console.log('failed');
                }.bind(this)).always(function () {
                    let resellerText = $('#reseller :selected').text();
                    dataLayerAA.event = {};
                    dataLayerAA.event.action = 'change account preference';
                    dataLayerAA.event.country = $('#country :selected').text();
                    dataLayerAA.event.salesOrg = $('#country :selected').val();
                    dataLayerAA.event.language = $('#language :selected').val();
                    dataLayerAA.event.currency = $('#currency :selected').val();
                    dataLayerAA.event.accountId = preferencesAccountId.join('|');
                    dataLayerAA.event.accountName = preferencesAccountName.join('|');
                    _satellite.track('event:user:user:preference');
                }.bind(this));
            }
        },

        /**
         * Update currency,reseller,language dropdowns when country is changed
         */
        updateResellersList: function () {
            var _this = this;
            this.model.fetch({
                data: {
                    code: this.$countryDropdown.val()
                }
            }).done(function (response) {
                _this.$currencyDropdown.html(_this.currencyTemplate(response));
                _this.$resellerDropdown.html(_this.accountTemplate(response));
                _this.$languageDropdown.html(_this.languageTemplate(response));
                _this.selectCheckBox();
            });
        },

        /**
         * Toggle select all products
         * @param {Object} ev - Event object
         */
        selectAll: function (ev) {
            this.$('[name=preferences]').each(function (index, item) {
                if (!item.disabled) {
                    item.checked = !!ev.currentTarget.checked;
                }
            });
            this.selectCheckBox(ev);
        },

        /**
         * Toggle select all related accounts
         * @param {Object} ev - Event object
         */
        selectRelatedCheckbox: function (ev) {
            let id = ev.target.id;
            this.$('.' + id + '').each(function (index, item) {
                if (!item.disabled) {
                    item.checked = !!ev.currentTarget.checked;
                }

            });
            this.selectCheckBox(ev);
        },

        selectCheckBox: function (ev) {
            this.$selectedCheckboxes = $('[name="preferences"]:checked').not(':disabled').length;
            this.$TotalCheckboxes = $('input:checkbox[name="preferences"]').not(':disabled').length;
            $('.select-all').prop('checked', this.$selectedCheckboxes === this.$TotalCheckboxes);

            if ($('.select-all').prop('checked')) {
                $('.mainGroupSelection').prop('checked', true);
            } else {
                $('.mainGroupSelection').each(function (index, item) {
                    let ids = $(item).attr('id');
                    if (ids !== '') {
                        let leng = $(item).attr('data-length');
                        let selectedLength = $('.' + ids + ':checked').not(':disabled').length;

                        // if any disabled vendor, minus from the total items
                        let disabledLength = $('.' + ids + ':disabled').length;
                        var totalLength = leng;
                        if (disabledLength > 0) {
                            totalLength = (parseInt(leng) - disabledLength);
                        }

                        $('#' + ids + '').prop('checked', totalLength == selectedLength);
                    }

                });
            }

            if (ev != undefined) {
                let preferenceGroup = $(ev.currentTarget).attr('class');
                let lengt = $('#' + preferenceGroup + '').attr('data-length');
                let selectedLength = $('.' + preferenceGroup + ':checked').not(':disabled').length;

                // if any disabled vendor, minus from the total items
                let disabledLength = $('.' + preferenceGroup + ':disabled').length;
                var lengtTotalLength = lengt;
                if (disabledLength > 0) {
                    lengtTotalLength = (parseInt(lengt) - disabledLength);
                }

                $('#' + preferenceGroup + '').prop('checked', lengtTotalLength == selectedLength);
            }

            this.checkCheckboxesAndEnableSaveButton();
        },

        /**
         * Check checkboxes and enable/disable save button
         */
        checkCheckboxesAndEnableSaveButton () {
            this.$submitButton.attr('disabled', this.$selectedCheckboxes <= 1);
            if (this.$selectedCheckboxes <= 1) {
                this.$submitButton.addClass('isDisabled');
            } else {
                this.$submitButton.removeClass('isDisabled');
            }
        },

        /**
         * Update currency dropdown when reseller account is changed.
         */
        updateCurrency: function () {
            var _this = this;
            var selectedReseller = this.$resellerDropdown.val();
            var selectedSalesOrg = this.$countryDropdown.val();
            this.currencyModel.fetch({
                data: {
                    code: selectedSalesOrg,
                    reseller: selectedReseller
                },
                success: function (response) {
                    if (response.error) {
                        console.error(`Server error while updating currency: ${response.error}`);
                        return;
                    }

                    _this.$currencyDropdown.html(_this.currencyTemplate(response.toJSON()));
                },

                error: function (jqXHR, textStatus, errorThrown) {
                    console.error(`Communication error while updating currency: ${textStatus}`, errorThrown);
                }
            });

        }
    });
})(westcon);
